import { Pipe, PipeTransform } from '@angular/core';

import { IdValue } from '../models/id-value.model';

/**
 * Pulls name out of Id, value, name pair IdValue and exclude two items
 * Using for 1008 components
 */
@Pipe({ name: 'toNameOrValueNoSelect' })
export class ToNameOrValueNoSelectPipe implements PipeTransform {
  transform(id: number, idValueArray: IdValue[], prop = 'value'): string {
    const item = idValueArray.find((t) => t.id === id);
    if (item) {
      return this._isStringExcluded(item[prop]) ? '-' : item[prop];
    } else {
      return '-';
    }
  }

  private _isStringExcluded(input: string): boolean {
    const excludeValues = ['select', 'notassigned'];
    const lowerCaseString = input.toLowerCase();
    const stringWithoutSpaces = lowerCaseString.replace(/\s/g, '');
    return excludeValues.includes(stringWithoutSpaces);
  }
}
